<div class="bg-main site-footer">
    <div class="container-footer">
        <div class="p-grid">
            <div class="p-col-6 d-flex justify-content-end">
                <div class="p-col footer-logos">
                    <a href="http://www.vnpost.vn/" target="_blank"><img src="assets/images/vnpost-logo.svg" alt="" class="img-fluid"></a>
                </div>
            </div>
            <div class="p-col-6 d-flex justify-content-end">
                <a href="https://apps.apple.com/vn/app/vpostcode/id1510533006?l=vi" class="no-effect mr-1">
                    <img src="assets/images/app-store-logo.svg" alt="" class="img-fluid" style="height: 40px;">
                </a>
                <a href="https://apkpure.com/vpostcode/vn.vpostcode.application" class="no-effect">
                    <img src="assets/images/google-play-logo.svg" alt="" class="img-fluid" style="height: 40px;">
                </a>
            </div>
        </div>
        <hr>
        <div class="p-grid">
            <div class="p-md-6 p-lg-5 p-xl-5">
                <h4 class="text-white">TỔNG CÔNG TY BƯU ĐIỆN VIỆT NAM</h4>
                <p>
                    Địa chỉ: Số 05 đường Phạm Hùng<br> Mỹ Đình 2 - Nam Từ Liêm<br> Hà Nội - Việt Nam
                </p>
                <p class="copyright d-none d-md-block">
                    © Copyright 2020 Vpostcode <a href="http://saijinstudio.com" target="_blank"> Designed by SaijinStudio</a>
                </p>
            </div>
            <div class="p-md-6 p-lg-3 p-xl-3 column-flex companion-unit">
                <div>
                    <p class="mb-3">Đối tác về công nghệ</p>
                    <p class="mb-0">
                        <a href="javascript:;" class="no-effect">
                            <img src="assets/images/vietmap-logo.svg" alt="" class="img-fluid" width="90">
                        </a>
                    </p>
                </div>
            </div>
            <div class="p-md-6 p-lg-1 p-lg-0">
                <ul class="list-unstyled">
                    <li>
                        <a routerLink="/">Trang chủ</a>
                    </li>
                    <li>
                        <a routerLink="/about">Giới thiệu</a>
                    </li>
                    <li>
                        <a routerLink="/benefit">Lợi ích</a>
                    </li>
                    <li>
                        <a routerLink="/question">Hỏi đáp</a>
                    </li>
                </ul>
            </div>
            <div class="p-md-6 p-lg-3 pb-3">
                <div class="d-flex justify-content-start justify-content-lg-end">
                    <ul class="list-unstyled">
                        <li>
                            <a routerLink="/contact">Liên hệ</a>
                        </li>
                        <li>
                            <a class="rounded-lg py-1 px-3 d-flex align-items-center hotline-link no-effect" href="tel:1900545481">
                                <i class="phone-icon"></i>&nbsp; Hotline:&nbsp;
                                <strong>1900 54 54 81</strong>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="d-flex justify-content-start justify-content-lg-end mt-2">
                    <ul class="list-inline mt-2 mb-0">
                        <li class="list-inline-item">
                            <a href="https://www.facebook.com/MaDiaChi" target="_blank"><i class="fab fa-facebook-f"></i></a>
                        </li>
                        <li class="list-inline-item">
                            <a href="https://twitter.com/vietnam_post" target="_blank"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="list-inline-item">
                            <a href="https://www.linkedin.com/company/vietnampost/" target="_blank"><i class="fab fa-linkedin-in"></i></a>
                        </li>
                        <li class="list-inline-item">
                            <a href="https://www.youtube.com/channel/UCNo_DAJzrmgoaNZ2E8FXHTA" target="_blank"><i class="fab fa-youtube"></i></a>
                        </li>
                        <li class="list-inline-item">
                            <a href="https://www.instagram.com/buudienvietnam/" target="_blank"><i class="fab fa-instagram"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="p-12 d-md-none">
                <p class="copyright">
                    © Copyright 2020 Vpostcode. <a href="http://saijinstudio.com">
                        Designed by
                        SaijinStudio
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>